import type { CurrentUser, SessionAdapter } from '@zhiyue/core';

import { BizAppConfig } from 'config/application.manifest';
import {
  createTenant as createTenantApi,
  deleteTenant as deleteTenantApi,
  getCurrentMemberUser,
  getTenantByCode as getTenantByCodeApi,
  getTenantList as getTenantListApi,
  joinTenant as joinTenantApi,
  logout as logoutApi,
  switchTenant as switchTenantApi,
} from '@/services/bff';
import { clearOpenPlatformToken } from '@/services/openPlatformToken';
import { readCurrentTenantUuid, saveCurrentTenantUuid } from './tenantStorage';

export const sessionAdapter: SessionAdapter = {
  fetchCurrentUser: async () => {
    const user = (await getCurrentMemberUser()) as CurrentUser &
      API.CurrentUser;
    console.log('[memberUuid][frontend] current session user', {
      memberUuid: user.memberUuid,
      userUuid: user.uuid,
      tenantUuid: user.tenantUuid,
      organizationUuid: user.organizationUuid,
    });
    saveCurrentTenantUuid(user.tenantUuid);
    return user;
  },
  fetchTenants: async () => {
    const result = await getTenantListApi();
    if (!readCurrentTenantUuid()) {
      saveCurrentTenantUuid(result?.[0]?.id);
    }
    return result || [];
  },
  switchTenant: async (organizationUuid: string) => {
    const result = await switchTenantApi(organizationUuid);
    saveCurrentTenantUuid(result?.tenantUuid);
  },
  createTenant: async ({ tenantName }: { tenantName: string }) => {
    const result = await createTenantApi({ tenantName });
    saveCurrentTenantUuid(result?.tenantUuid);
    return result;
  },
  lookupTenantByCode: async (code: string) => getTenantByCodeApi(code),
  joinTenant: async (payload: { tenantUuid: string; nodeId: string }) => {
    const result = await joinTenantApi(payload);
    saveCurrentTenantUuid(result?.tenantUuid);
    return result;
  },
  deleteTenant: async (tenantUuid: string) => {
    const result = await deleteTenantApi(tenantUuid);
    saveCurrentTenantUuid(result?.tenantUuid || null);
    return result;
  },
  logout: async () => {
    const logoutBaseUrl = BizAppConfig.appSsoLogoutUrl;
    const logoutUrl = `${logoutBaseUrl}?redirect_uri=${encodeURIComponent(`${window.location.origin}/user/login`)}`;

    try {
      await logoutApi(BizAppConfig.appSsoClientId as string);
    } catch {
      // Keep local logout flow even when backend logout fails.
    }

    clearOpenPlatformToken();
    saveCurrentTenantUuid(null);
    return { logoutUrl };
  },
};
